import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, serchSelect } from "@/mixins/index";
import addpersonCast from "./components/addpersonCast";
export default {
  name: "personCast",
  mixins: [loadMoreList, serchSelect],
  components: {
    addpersonCast: addpersonCast
  },
  data: function data() {
    return {
      pagingReqFn: "roleBannerData",
      pagingReqValue: "",
      paramsData: {
        id: '',
        name: '',
        language: ''
      },
      tableBody: 'personCastTable',
      sortReq: 'roleBannerChangeSort'
    };
  },
  activated: function activated() {
    this.getList();
  },
  methods: {
    del: function del(dateList) {
      var _this = this;

      var ids = dateList.map(function (item) {
        return item.id;
      });
      this.$store.dispatch('d2admin/method/deleteList', {
        req: 'roleBannerDel',
        data: {
          id: ids.toString()
        }
      }).then(function () {
        _this.getList();
      });
    }
  }
};